import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";

import { UserState } from "./modules/user";
import { CustomerState } from "./modules/customers";
import { ProductState } from "./modules/products";
import { FlotaState } from "./modules/flotas";
import { AppState } from "./modules/app";

Vue.use(Vuex);

interface RootState {
  appState: AppState;
  userState: UserState;
  customerState: CustomerState;
  productState: ProductState;
  flotaState: FlotaState;
}

export default new Vuex.Store<RootState>({
  // plugins: [createPersistedState({ storage: window.sessionStorage })] // !debug ? [createPersistedState({ storage: window.sessionStorage })] : [],
});
